<template>
    <div>
        <div class="loading">
            <van-loading type="spinner" size="30px">加载中...</van-loading>
        </div>
    </div>
</template>

<script>
    export default {
       name:"loading" 
    }
</script>

<style lang="less" scoped>
.loading {
    position: absolute;
    top:50%;
    left:45%;
}
</style>